import { Group, type GroupProps } from "@mantine/core"

export function AppTitle(props: GroupProps) {
  return <Group fz="xl" fw={600} gap="xs" {...props} />
}
